import ChromeLoading from './chrome-loading'
import DbCircle from './db-circle'
export default {
	ChromeLoading,
	DbCircle
}
